module.exports = __webpack_public_path__ + "img/pencil.afad546c.svg";